import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { OrgDashboardApiOrg } from '#/modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { trackAnchorClicked } from '#/utils/analytics/track/trackAnchorClicked';
import { formatCalendarDateShort } from '#/utils/date';

const contactLink = (
  <StyledNativeLinkWithRef
    href="https://www.idealist.org/en/about/contact"
    target="_blank"
    onClick={(event) =>
      trackAnchorClicked(event, 'Org Preview - Contact Idealist')
    }
  />
);

type Args = {
  i18n: I18nFn;
  locale: I18nLocale;
  org: OrgDashboardApiOrg;
};

export function getOrgPreviewInfoMessage({ i18n, locale, org }: Args) {
  const createdDate = formatCalendarDateShort({ date: org.created, locale });
  const submittedToday =
    createdDate === formatCalendarDateShort({ date: Date.now(), locale });

  if (submittedToday) {
    if (org.is501c3) {
      return i18n(
        'Thank you! Your organization has been submitted for approval and will be reviewed within two business days. In the meantime, you can customize your profile, create a job listing, or contact the {{link}}Idealist Community Support Team{{/link}} if you have any questions.',
        { link: contactLink },
      );
    }

    return i18n(
      'Thank you! Your organization has been submitted for approval and will be reviewed within two business days. In the meantime, you can customize your profile or contact the {{link}}Idealist Community Support Team{{/link}} if you have any questions.',
      { link: contactLink },
    );
  }

  if (org.is501c3) {
    return i18n(
      'Your organization was submitted for approval on %(createdDate)s. In the meantime, you can customize your profile or create a job listing. If you have any questions or if it has been more than two business days since applying, please contact the {{link}}Idealist Community Support Team{{/link}}.',
      { createdDate, link: contactLink },
    );
  }

  return i18n(
    'Your organization was submitted for approval on %(createdDate)s. In the meantime, you can customize your profile. If you have any questions or if it has been more than two business days since applying, please contact the {{link}}Idealist Community Support Team{{/link}}.',
    { createdDate, link: contactLink },
  );
}
